export default "__VITE_ASSET__d5e65c25__"